import { useMemo } from 'react';
import { useGetTodoTypeLabel } from 'views/Todo/hooks/useLabel';

interface TabTitleProps {
  type: Todo.Type;
  typeName: string;
  subType?: string;
  subType2?: string;
  subType3?: string;
}
export const TabTitle = (props: TabTitleProps) => {
  const { type, typeName, subType, subType2, subType3 } = props;
  const { getTodoTypeLabel } = useGetTodoTypeLabel();

  const subTypeStr = useMemo(() => {
    return [subType, subType2, subType3].filter(Boolean).join('/');
  }, [subType, subType2, subType3]);

  const title = useMemo(() => {
    return `${getTodoTypeLabel(type, typeName)}${subTypeStr ? `/${subTypeStr}` : ''}`;
  }, [getTodoTypeLabel, type, typeName, subTypeStr]);

  return (
    <div className="max-w-[240px] truncate" title={title}>
      {title}
    </div>
  );
};
